import { SortDirection } from "@spz/shared-domain";
import type { SortingState } from "@tanstack/react-table";

export const getNextSortingState = (
  sorting: SortingState,
  updatedSorting: SortingState,
): {
  sortField: string | null;
  sortDirection: SortDirection | null;
} => {
  if (sorting.length === 0 && updatedSorting.length === 0) {
    // Case 1: No previous sort AND no new sort
    throw new Error(
      "Invalid sorting state: both previous and new sorting are empty arrays.",
    );
  }

  const [previousSort] = sorting;
  const [newSort] = updatedSorting;

  if ((!previousSort && !newSort) || !newSort || !newSort.id) {
    // Case 2: updatedSorting is empty or newSort.id is undefined
    return { sortField: null, sortDirection: null };
  }

  if (!previousSort || previousSort.id !== newSort.id) {
    // Case 3: No previous sort OR previous id and new id are different
    return { sortField: newSort.id, sortDirection: SortDirection.ASC };
  }

  if (!previousSort.desc) {
    // Case 4: Previous sort direction is ASC and same id clicked
    return { sortField: newSort.id, sortDirection: SortDirection.DESC };
  }

  return { sortField: null, sortDirection: null };
};
